module.exports = __webpack_public_path__ + "img/2017-1.7d7c5f4c.jpg";